<template>
    <modal id="house-keeping-modal"
           size="large"
           v-model="showModal"
           :title="$t('update_price')"
           :btn-label="$t('run')"
           @submit="submitData" :loading="loading"
           :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/hotel/house-keeping/bulk`'
            @submit.prevent="submitData"
        >
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('hotel')"
                        list-value-field="name"
                        v-model="formData.hotel_id"
                        :chooseLabel="$t('hotel')"
                        :error-message="$errorMessage(errors, 'hotel_id')"
                        :fetch-url="`${TENANT_BASE_URL}selectable/hotel/list`"
                        @change="updatePrice()"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('type')"
                        list-value-field="name"
                        v-model="formData.type_id"
                        :chooseLabel="$t('type')"
                        :error-message="$errorMessage(errors, 'type_id')"
                        :fetch-url="type_url"
                        @change="updatePrice()"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('start_date')"
                        v-model="formData.start_date"
                        :placeholder="formData.start_date ? $placeholder('date') : this.$t('not_added_yet')"
                        :error-message="$errorMessage(errors, 'start_date')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('end_date')"
                        v-model="formData.end_date"
                        :placeholder="formData.end_date ? $placeholder('date') : this.$t('not_added_yet')"
                        :error-message="$errorMessage(errors, 'end_date')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('staying')"
                        list-value-field="name"
                        v-model="formData.staying_id"
                        :chooseLabel="$t('staying')"
                        :error-message="$errorMessage(errors, 'staying_id')"
                        :fetch-url="staying_url"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('cleaning')"
                        list-value-field="name"
                        v-model="formData.cleaning_id"
                        :chooseLabel="$t('cleaning')"
                        :error-message="$errorMessage(errors, 'cleaning_id')"
                        :fetch-url="cleaning_url"
                        @change="updatePrice()"
                    />
                </div>

                <div class="col-md-6">
                    <app-form-group
                        type="number"
                        :label="$t('contract_price')"
                        :placeholder="$placeholder('contract_price')"
                        v-model="formData.contract_price"
                        :error-message="$errorMessage(errors, 'contract_price')">
                    </app-form-group>
                </div>
                <div class="col-md-6">
                    <app-form-group
                        type="number"
                        :label="$t('selling_price')"
                        :placeholder="$placeholder('selling_price')"
                        v-model="formData.selling_price"
                        :error-message="$errorMessage(errors, 'selling_price')">
                    </app-form-group>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {formatDateForServer} from "../../../../../common/Helper/Support/DateTimeHelper";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";

export default {
    name  : "HouseKeepingBulkModal",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            TENANT_BASE_URL,
            type_url    : null,
            staying_url : null,
            cleaning_url: null,
            formData    : {
                contract_price: 0,
                selling_price : 0,
            },
        }
    },
    watch  : {
        'formData.hotel_id': {
            handler  : function (value) {
                const hotel_id    = value && typeof value !== "undefined" ? value : 0
                this.type_url     = `${TENANT_BASE_URL}selectable/hotel/type?hotel_id=${hotel_id}`
                this.staying_url  = `${TENANT_BASE_URL}selectable/hotel/staying?hotel_id=${hotel_id}`
                this.cleaning_url = `${TENANT_BASE_URL}selectable/hotel/cleaning?hotel_id=${hotel_id}`
            },
            immediate: true
        },
    },
    methods: {
        submitData() {
            this.loading   = true
            const url      = this.$refs.form.dataset["url"];
            const formData = formDataAssigner(new FormData, this.formData);

            formData.append('start_date', formatDateForServer(this.formData.start_date))
            formData.append('end_date', formatDateForServer(this.formData.end_date))

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {
                contract_price: 0,
                selling_price : 0,
            };
            $('#house-keeping-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'house-keeping-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData  = response.data;
            this.options   = response.data.options || [];
        },
        updatePrice() {
            if (this.formData.type_id && this.formData.cleaning_id && this.formData.hotel_id) {
                axiosGet(`${TENANT_BASE_URL}selectable/hotel/pricing?hotel_id=${this.formData.hotel_id}&type_id=${this.formData.type_id}&cleaning_id=${this.formData.cleaning_id}`).then(({data}) => {
                    if (data.length && data[0].contract_price) {
                        this.formData.contract_price = parseInt(data[0].contract_price)
                        this.formData.selling_price  = parseInt(data[0].selling_price)
                    } else {
                        this.formData.contract_price = 0
                        this.formData.selling_price  = 0
                    }
                }).catch(error => this.$toastr.e(error.response.data.message))
            } else {
                this.formData.contract_price = 0
                this.formData.selling_price  = 0
            }
        },
    },
}
</script>

